<ac-card class="level-up-rewards-list-dialog">
  <ac-card-header [hideBack]="true" (close)="close()" />

  <ac-card-content>
    <div class="ac-headline-sm ac-text-ctr">Level Up Rewards</div>

    <div class="rewards ac-flex-col ac-gap-md">
      @for (reward of rewards(); track reward.claim.vip_level_up_claim_id) {
        <div class="reward-row ac-flex ac-algn-ctr ac-gap-md">
          <div class="row-badge ac-flex ac-ctr">
            @if (badgeUrl(reward); as logo) {
              <img [src]="logo" [alt]="title(reward)" class="row-logo" />
            } @else {
              <ac-icon iconKey="hr:vip_level" [size]="40" />
            }
          </div>

          <div class="row-info ac-flex-col ac-gap-xs">
            <div class="ac-title-md">{{ title(reward) }} Level Up</div>
            <div class="row-amounts ac-flex ac-algn-ctr ac-gap-md ac-body-md">
              <span class="ac-flex ac-algn-ctr ac-gap-xs">
                <app-gc-icon type="3d" [size]="16" />
                {{ reward.claim.reward_gc | number }}
              </span>
              <span class="ac-flex ac-algn-ctr ac-gap-xs">
                <app-sc-icon type="3d" [size]="16" />
                {{ reward.claim.reward_sc | number: '0.0-2' }}
              </span>
            </div>
          </div>

          <button
            mat-flat-button
            type="button"
            class="row-claim"
            [loading]="claimingId() === reward.claim.vip_level_up_claim_id"
            [disabled]="timeout() || (!!claimingId() && claimingId() !== reward.claim.vip_level_up_claim_id)"
            [disabledInteractive]="true"
            [matTooltip]="timeout()"
            [matTooltipDisabled]="!timeout()"
            (click)="claim(reward)"
          >
            Claim
          </button>
        </div>
      }
    </div>
  </ac-card-content>
</ac-card>
